<template>
  <div class="c-expired">
    <p>
      <strong>{{ copy.title }}</strong>
      <br/>
      {{ copy.body }}
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Preview",
  computed: {
    ...mapState({
      signupMoment: state => state.signupMoment,
    }),
    copy() {
      return this.signupMoment.copy?.default
    },
  },
};
</script>

<style lang="scss" scoped>
.c-expired {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
</style>
